import React, {useState} from 'react';
import {Col, Label, Row} from 'reactstrap';
import {AvForm, AvGroup, AvInput} from 'availity-reactstrap-validation';
import {IPatientBaby} from 'app/shared/model/patient-baby.model';
import {StepComponentProps} from '../followup-modal';
import FollowupButtons from '../followup-buttons';

interface BabyInfoStepProps extends StepComponentProps {
  updateCurrentBaby?: (updates: Partial<IPatientBaby>) => void;
  currentBabyIndex?: number;
}

const BabyInfoStep: React.FC<BabyInfoStepProps> = ({
                                                     formData,
                                                     updateFormData,
                                                     onNext,
                                                     onPrevious,
                                                     canGoBack,
                                                     canGoNext,
                                                     patientCaseType,
                                                     journey,
                                                     patientInfo,
                                                     onSave,
                                                     updating,
                                                     updateCurrentBaby,
                                                     currentBabyIndex = 0,
                                                   }) => {
  // Get current baby data
  const currentBaby = formData.patientBabies?.[currentBabyIndex];
  const [babyFirstName, setBabyFirstName] = useState(currentBaby?.firstName || '');
  const [babyLastName, setBabyLastName] = useState(currentBaby?.lastName || '');
  const [babyBirthDate, setBabyBirthDate] = useState(currentBaby?.birthDate || '');
  const [babySex, setBabySex] = useState(currentBaby?.sex || '');

  const handleSubmit = (event: any, values: any) => {
    // All fields are mandatory
    if (!babyFirstName || !babyLastName || !babyBirthDate || !babySex) {
      return;
    }

    // Update current baby with personal info
    if (updateCurrentBaby) {
      updateCurrentBaby({
        firstName: babyFirstName,
        lastName: babyLastName,
        birthDate: babyBirthDate,
        sex: babySex,
      });
    }

    if (onNext) {
      onNext();
    }
  };

  return (
    <div className="followup-step-container">
      <div className="followup-step-content">
        <h6 className="mb-4">Add Baby{currentBabyIndex > 0 ? `#${currentBabyIndex + 1}` : ''} Information</h6>
        <AvForm onValidSubmit={handleSubmit}>
          <Row>
            <Col md="12">
              <AvGroup>
                <Label for="babyFirstName">Baby&apos;s First Name</Label>
                <AvInput
                  type="text"
                  name="babyFirstName"
                  id="babyFirstName"
                  value={babyFirstName}
                  onChange={e => setBabyFirstName(e.target.value)}
                  placeholder="Add the baby's first name"
                  required
                />
              </AvGroup>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <AvGroup>
                <Label for="babyLastName">Baby&apos;s Last Name</Label>
                <AvInput
                  type="text"
                  name="babyLastName"
                  id="babyLastName"
                  value={babyLastName}
                  onChange={e => setBabyLastName(e.target.value)}
                  placeholder="Add the baby's last name"
                  required
                />
              </AvGroup>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <AvGroup>
                <Label for="babyBirthDate">Baby&apos;s Date of Birth</Label>
                <AvInput
                  type="date"
                  name="babyBirthDate"
                  id="babyBirthDate"
                  value={babyBirthDate}
                  onChange={e => setBabyBirthDate(e.target.value)}
                  placeholder="Add the baby's birth date"
                  required
                />
              </AvGroup>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <AvGroup>
                <Label for="babySex">Baby&apos;s Gender</Label>
                <AvInput
                  type="select"
                  name="babySex"
                  id="babySex"
                  value={babySex}
                  onChange={e => setBabySex(e.target.value)}
                  required
                >
                  <option value="">Select baby gender</option>
                  <option value="M">Male</option>
                  <option value="F">Female</option>
                </AvInput>
              </AvGroup>
            </Col>
          </Row>
          <FollowupButtons
            currentStep={11}
            totalSteps={13}
            canGoBack={canGoBack}
            onPrevious={onPrevious}
            isLastStep={false}
            updating={updating}
          />
        </AvForm>
      </div>
    </div>
  );
};

export default BabyInfoStep;
